/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  FarmingBonusHistoryItem,
  FarmingBonusHistoryItemFromJSON,
  FarmingBonusHistoryItemToJSON,
  TradingBonusHistoryItem,
  TradingBonusHistoryItemFromJSON,
  TradingBonusHistoryItemToJSON,
} from '../models'

/**
 *
 */
export class BonusHistoryApi extends runtime.BaseAPI {
  /**
   */
  async getFarmingHistoryRaw(
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<Array<FarmingBonusHistoryItem>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/bonuses/history/farming`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FarmingBonusHistoryItemFromJSON))
  }

  /**
   */
  async getFarmingHistory(initOverrides?: RequestInit): Promise<Array<FarmingBonusHistoryItem>> {
    const response = await this.getFarmingHistoryRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getTradingHistoryRaw(
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<Array<TradingBonusHistoryItem>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/bonuses/history/trading`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TradingBonusHistoryItemFromJSON))
  }

  /**
   */
  async getTradingHistory(initOverrides?: RequestInit): Promise<Array<TradingBonusHistoryItem>> {
    const response = await this.getTradingHistoryRaw(initOverrides)
    return await response.value()
  }
}
